import { IKogIcon } from '@/main/@types/interfaceIcons'
import React from 'react'

export function CarIcon({
  height = '50px',
  width = '50px',
  color = 'currentColor'
}: IKogIcon) {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 548.000000 454.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,454.000000) scale(0.100000,-0.100000)"
        fill={color}
        stroke="none"
      >
        <path d="M1517 4054 c-28 -15 -78 -112 -252 -486 -38 -82 -65 -128 -75 -128
          -8 0 -143 32 -299 70 -156 39 -303 70 -326 70 -85 0 -141 -84 -111 -166 7 -22
          72 -157 145 -301 72 -145 131 -265 131 -267 0 -3 -103 -92 -228 -199 -125
          -107 -233 -207 -240 -221 -17 -37 -15 -91 4 -127 22 -44 65 -59 367 -125 l268
          -58 -3 -332 c-3 -322 -2 -333 18 -361 32 -45 85 -66 131 -54 28 8 146 91 191
          136 10 10 57 213 48 208 -6 -4 -69 -54 -140 -112 l-129 -105 7 346 c7 329 6
          348 -12 366 -12 12 -108 39 -320 87 -166 38 -302 72 -302 75 0 3 57 55 127
          116 302 259 363 315 363 334 0 11 -70 160 -155 331 -111 220 -151 309 -138
          305 83 -25 628 -156 649 -156 15 0 35 7 44 15 8 8 79 151 155 319 77 168 143
          302 147 298 3 -4 68 -141 144 -306 76 -164 144 -304 151 -312 22 -22 64 -17
          271 34 l192 48 46 73 c25 40 43 75 41 78 -3 2 -104 -21 -225 -51 -121 -31
          -227 -56 -235 -56 -9 0 -59 99 -143 283 -145 319 -164 347 -235 347 -24 -1
        -57 -8 -72 -16z"
        />
        <path d="M3080 3703 c-99 -16 -219 -75 -294 -144 -86 -79 -133 -147 -351 -513
          l-200 -335 -73 -27 c-86 -31 -204 -106 -267 -169 -59 -59 -135 -176 -173 -267
          -17 -40 -69 -224 -117 -408 -47 -184 -107 -407 -132 -495 -53 -183 -57 -249
          -23 -320 25 -52 77 -101 135 -126 23 -10 107 -35 186 -54 157 -39 207 -40 284
          -6 81 37 119 99 166 276 18 66 36 124 40 128 5 7 2013 -518 2028 -530 3 -2
          -13 -63 -34 -136 -41 -141 -48 -220 -25 -279 22 -55 70 -107 120 -133 68 -34
          323 -97 391 -97 72 1 138 31 183 84 41 47 56 86 95 245 17 67 36 134 41 149
          15 39 147 538 176 664 28 125 32 265 8 367 -21 91 -89 233 -152 316 l-52 67
          -9 439 c-11 489 -17 535 -79 656 -24 47 -60 93 -108 141 -120 118 -144 127
          -879 322 -352 94 -667 175 -699 181 -59 11 -136 12 -186 4z m845 -308 c358
          -97 678 -189 712 -205 111 -51 196 -150 235 -273 16 -53 20 -109 28 -397 5
          -184 9 -360 10 -390 l0 -56 -87 42 c-74 35 -262 88 -1148 324 -797 212 -1085
          285 -1163 294 l-102 11 195 325 c125 207 212 342 243 373 87 90 224 140 357
          133 50 -3 256 -55 720 -181z m-1325 -801 c36 -8 522 -139 1080 -290 810 -220
          1032 -284 1098 -315 144 -69 251 -196 321 -378 23 -60 25 -80 25 -211 l-1
          -145 -80 -288 c-45 -159 -83 -291 -85 -293 -3 -2 -103 23 -224 57 -120 33
          -725 195 -1344 360 -1283 342 -1712 458 -1722 468 -4 3 31 143 78 311 103 375
          133 441 243 550 127 126 276 189 451 189 52 1 124 -6 160 -15z m-711 -1235
          c129 -33 238 -62 241 -64 11 -7 -57 -253 -80 -290 -26 -42 -66 -65 -113 -65
          -19 0 -97 18 -173 40 -119 35 -144 46 -171 75 -42 44 -42 65 -1 233 23 95 36
          132 47 132 8 0 120 -27 250 -61z m2746 -739 c105 -28 213 -58 241 -66 l51 -15
          -37 -122 c-42 -140 -61 -181 -93 -201 -48 -31 -74 -30 -230 15 -234 66 -244
          83 -186 312 34 136 35 138 52 132 7 -3 98 -27 202 -55z"
        />
        <path d="M2301 2276 c-90 -32 -161 -138 -161 -240 0 -102 47 -185 132 -232 46
          -25 64 -29 128 -29 58 0 85 6 116 22 81 43 144 147 144 238 0 52 -27 128 -61
          168 -48 58 -114 87 -196 86 -37 0 -83 -6 -102 -13z m152 -120 c71 -30 99 -101
          67 -174 -15 -34 -29 -47 -66 -63 -60 -27 -100 -19 -145 27 -29 30 -34 42 -34
          84 0 57 24 96 76 122 41 22 60 22 102 4z"
        />
        <path d="M4495 1711 c-95 -25 -165 -91 -191 -179 -19 -64 -13 -116 20 -187 44
          -94 131 -147 241 -147 189 0 316 203 231 370 -54 107 -191 172 -301 143z m135
          -148 c86 -51 77 -183 -15 -227 -64 -31 -136 -7 -175 57 -37 61 -15 135 52 178
          37 23 92 20 138 -8z"
        />
      </g>
    </svg>

  )
}
